import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonNote,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from "@ionic/react";
import {
  bookmarkOutline,
  shareOutline,
  homeOutline,
  home,
  phonePortraitOutline,
} from "ionicons/icons";
import { useParams } from "react-router";
import { blogPosts } from "./blogData";
import "./BlogPost.css";
import { truncate } from "../utils/truncate";
import SocialLinks from "./SocialLinks";
import ContactInfo from "./ContactInfo";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import Footer from "../views/Slides/Footer";

const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};

const BlogPost = (props) => {
  const params = useParams();
  const id = props.id || params.id;
  const post = blogPosts.find((post) => post.id === id);
  const CONTACT_POST_ID = "contact-us";
  const SOCIAL_POST_ID = "info";
  const BUILDING_LOONLOG = createSlug(
    "Building LoonLog: Canada’s Own Social Media Platform"
  );
  const YOUR_STORY = createSlug(
    "Your Story, Our Story: The Heart of Community on LoonLog"
  );
  const WHY_LOONLOG = createSlug("Why LoonLog Is More Than Social Media");
  const isBuildingLoonLogPost = post?.id === BUILDING_LOONLOG;
  const isYourStoryPost = post?.id === YOUR_STORY;
  const isWhyLoonLogPost = post?.id === WHY_LOONLOG;
  const isAbout = post?.id === "about";
  const router = useIonRouter();
  useEffect(() => {
    if (isBuildingLoonLogPost) {
      document.title =
        "Canada’s Social Media Platform: Building LoonLog for Canadian Communities";

      const meta = document.querySelector("meta[name='description']");
      if (meta) {
        meta.setAttribute(
          "content",
          "LoonLog is a Canadian-owned social media platform built in Canada for Canadian communities. Learn why LoonLog exists, what makes it different, and how it connects Canadians coast to coast."
        );
      }
    }
    if (isYourStoryPost) {
      document.title =
        "Your Story, Our Story: Building Digital Community | LoonLog";
      const meta = document.querySelector("meta[name='description']");
      if (meta) {
        meta.setAttribute(
          "content",
          "Discover 'story stitching' on LoonLog. Learn how Canadian stories weave together to create a unique digital tapestry rooted in trust, shared values, and community."
        );
      }
    }

    // 2. "Why LoonLog" Blog Post
    if (isWhyLoonLogPost) {
      document.title =
        "Why LoonLog Is More Than Social Media: A Human Approach";
      const meta = document.querySelector("meta[name='description']");
      if (meta) {
        meta.setAttribute(
          "content",
          "LoonLog is a community-first platform featuring LoonLock privacy, collaborative learning, and local marketplaces. Experience social media that feels human again."
        );
      }
    }
  }, [isBuildingLoonLogPost, isYourStoryPost, isWhyLoonLogPost]);
  if (!post || !post.inBlog) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Post Not Found</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <p>😔 The blog post you're looking for doesn’t exist.</p>
        </IonContent>
      </IonPage>
    );
  }

  return (
    <>
      {isBuildingLoonLogPost && (
        <Helmet>
          <title>
            Canada’s Social Media Platform: Building LoonLog for Canadian
            Communities
          </title>

          <meta
            name="description"
            content="LoonLog is a Canadian-owned social media platform built in Canada for Canadian communities. Learn why LoonLog exists, what makes it different, and how it connects Canadians coast to coast."
          />

          <link
            rel="canonical"
            href="https://loonlog.ca/blog/building-loonlog-canada-s-own-social-media-platform"
          />
        </Helmet>
      )}

      <IonPage className="info-blog-post-page">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton
                defaultHref="/blog"
                mode="ios"
                text=""
                className="transparent-back-button"
              />
            </IonButtons>
            {/* <IonTitle style={{ padding: "10px" }} className="poetsen"> */}
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "7px",
              }}
              className="poetsen"
            >
              <img
                src="/logo4.png"
                alt="LoonLog Logo"
                style={{ height: "30px" }} // Adjust height and margin as needed
              />
              LoonLog
            </div>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <img src={post.image} alt="post header" />

          <IonGrid
            className="ion-padding-start ion-padding-end"
            style={{ paddingTop: "8px" }}
          >
            <IonRow className="ion-align-items-center ion-justify-content-between">
              <IonRow className="ion-align-items-center ion-justify-content-between">
                <img
                  src={post.authorImage}
                  className="blog-author-avatar"
                  alt="post author"
                />
                <IonCardSubtitle
                  className="ion-no-margin ion-no-padding ion-margin-start"
                  style={{ textTransform: "capitalize" }}
                >
                  {post.author}
                </IonCardSubtitle>
                {post.id !== WHY_LOONLOG &&
                  post.id !== BUILDING_LOONLOG &&
                  post.id !== YOUR_STORY && (
                    <h1
                      className="blog-title"
                      style={{
                        marginTop: "0.75rem",
                        marginBottom: "1rem",
                        fontSize: "1.1rem",
                        color: "#262626",
                        lineHeight: "1.3",
                        fontWeight: "500",
                      }}
                    >
                      {post?.title}
                    </h1>
                  )}
              </IonRow>
              <IonNote style={{ fontSize: "1rem" }}>{post.date}</IonNote>
            </IonRow>

            <IonRow>
              <IonCol size="12">
                {post.id === WHY_LOONLOG && (
                  <h1
                    className="blog-title"
                    style={{
                      marginTop: "0.75rem",
                      marginBottom: "0.75rem",
                      fontSize: "1.1rem",
                      color: "#262626",
                      lineHeight: "1.3",
                      fontWeight: "500",
                    }}
                  >
                    {post?.title}
                  </h1>
                )}
                {post.id === BUILDING_LOONLOG && (
                  <h1
                    className="blog-title"
                    style={{
                      marginTop: "0.75rem",
                      marginBottom: "0.75rem",
                      fontSize: "1.1rem",
                      color: "#262626",
                      lineHeight: "1.3",
                      fontWeight: "500",
                    }}
                  >
                    {post?.title}
                  </h1>
                )}
                {post.id === YOUR_STORY && (
                  <h1
                    className="blog-title"
                    style={{
                      marginTop: "0.75rem",
                      marginBottom: "0.75rem",
                      fontSize: "1.1rem",
                      color: "#262626",
                      lineHeight: "1.3",
                      fontWeight: "500",
                    }}
                  >
                    {post?.title}
                  </h1>
                )}
              </IonCol>
            </IonRow>

            <IonRow>
              <IonCol size="12">
                {/* {post.id === 8 ? (
                <SocialLinks />
              ) : (
                <IonText
                  color="medium"
                  style={{ whiteSpace: "pre-wrap", fontSize: "14px" }}
                >
                  {post.content}
                </IonText>
              )} */}
                <IonRow>
                  <IonCol size="12">
                    {post.id === SOCIAL_POST_ID ? (
                      <SocialLinks />
                    ) : post.id === CONTACT_POST_ID ? ( // NEW: Render custom ContactInfo component
                      <ContactInfo />
                    ) : (
                      // Default content rendering
                      // <IonText
                      //   color="medium"
                      //   style={{
                      //     whiteSpace: "pre-wrap",
                      //     fontSize: "14px",
                      //     color: "black",
                      //   }}
                      // >
                      //   {post.content}
                      // </IonText>
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          fontSize: "14px",
                          color: "black",
                          paddingBottom: "20px",
                          // Inherit the medium color style from IonText if desired
                        }}
                        className="blog-content-container" // Add this class
                        // ⚠️ SECURITY NOTE: Only use this if you trust the source of post.content!
                        // The linkify function should only convert URLs, making it safer,
                        // but be aware of the implications of this prop.
                        dangerouslySetInnerHTML={{
                          __html: post.content,
                        }}
                      />
                    )}
                  </IonCol>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonGrid>
          <Footer />
        </IonContent>

        {post.id !==
          createSlug("Building LoonLog: Canada’s Own Social Media Platform") &&
        post.id !==
          createSlug(
            "Your Story, Our Story: The Heart of Community on LoonLog"
          ) &&
        post.id !== createSlug("Why LoonLog Is More Than Social Media") ? (
          <IonFooter className="view-blog-footer info-post-card">
            <IonRow className="blog-footer ion-align-self-center ion-justify-content-between">
              <div>
                <span onClick={() => router.push("/")}>
                  <IonButton fill="clear" color="primary">
                    {/* 📲 */}
                    <IonIcon
                      icon={phonePortraitOutline}
                      style={{ fontSize: "16px", opacity: 0.7 }}
                    />
                  </IonButton>
                </span>

                <IonButton fill="clear" color="primary">
                  🇨🇦
                </IonButton>
              </div>

              <IonBadge color="primary" className="blog-category">
                {truncate(post.category, 18)}
              </IonBadge>
            </IonRow>
          </IonFooter>
        ) : (
          <IonFooter className="view-blog-footer">
            <IonRow className="blog-footer ion-align-items-center ion-justify-content-between">
              <div
                className="footer-promo"
                aria-label="Launching soon across Canada"
              >
                <div
                  className="footer-promo"
                  aria-label="Launching soon across Canada"
                >
                  🚀 <span className="canada-flag">🇨🇦</span>
                  <span className="promo-text">
                    Launching soon across{" "}
                    <span className="brand-color">Canada</span>
                  </span>
                </div>
              </div>
              {/* Category badge */}
              <IonBadge color="primary" className="blog-category">
                {truncate(post.category, 18)}
              </IonBadge>
            </IonRow>
          </IonFooter>
        )}
      </IonPage>
    </>
  );
};

export default BlogPost;
